import { Loader } from '../Loader/Loader';

/**
 * The grid's loading overlay, drawn with the app's own loader.
 *
 * ag-grid's default is a "Loading..." pill with its own spinner, which is the one place in
 * the app a wait looks different from everywhere else.
 */
export function GridLoadingOverlay() {
  return <Loader />;
}
